import { render, staticRenderFns } from "./ClassData.vue?vue&type=template&id=cea1cda8&scoped=true&"
import script from "./ClassData.vue?vue&type=script&lang=js&"
export * from "./ClassData.vue?vue&type=script&lang=js&"
import style0 from "./ClassData.vue?vue&type=style&index=0&id=cea1cda8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cea1cda8",
  null
  
)

export default component.exports